import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { SwalService } from '../../../../shared/services/swal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { EventModel, EventSubscriptionType, EventType } from '../../../../shared/interfaces/event.model';
import { takeUntil } from 'rxjs/operators';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
import { Subject } from 'rxjs';
import {CreateEditPermissionsControllerComponent} from './create-edit-permissions-controller/create-edit-permissions-controller.component';
import {PermissionsService} from '../../../../services/permissions.service';

@Component({
  selector: 'app-permissions-controller',
  templateUrl: './permissions-controller.component.html',
  styleUrls: ['./permissions-controller.component.scss']
})
export class PermissionsControllerComponent implements OnInit {
  dtConfig = {
    config: {
      base: this.permissionsService,
      api: 'datatable',
      rowsPerPage: 10,
      order: [[1, 'desc']],
      params: {
        key: ''
      }
    },
    columns: [
      {
        title: 'ID',
        field: 'id'
      },
      {
        title: 'Nombre',
        field: 'name',
      },
      {
        title: 'Guard Name',
        field: 'guard_name',
      }
    ],
    actions: [
      {
        display: 'Editar',
        icon: 'fa-pencil',
        event: 'permissions.edit',
        conditionality: 'true'
      },
      {
        display: 'Eliminar',
        icon: 'fa-trash',
        event: 'permissions.delete',
        conditionality: 'true'
      }
    ]
  };
  private atComponentDestroy = new Subject();
  constructor(
    private swal: SwalService,
    private broadcast: BroadcastService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private  nrModal: NRModalService,
    private permissionsService: PermissionsService
  ) { }

  ngOnDestroy(): void {
    this.atComponentDestroy.next();
    this.atComponentDestroy.unsubscribe();
  }
  ngOnInit(): void {
    this.broadcast
      .onEvent(EventSubscriptionType.TYPE, EventType.MODAL)
      .pipe(takeUntil(this.atComponentDestroy))
      .subscribe((event: EventModel) => {
        const props = this.prepareProps(event);
        if (props) {
          this.nrModal.open(props, 'md');
        }
      });
  }
   prepareProps(event: EventModel): any {
      const props: DynamicHostModel = new DynamicHostModel();
      props.instantiated = false;
      props.modalModel = {
        component: null,
        componentFactoryResolver: this.componentFactoryResolver,
        data: event.data.item || {}
      };
  
      switch (event.name) {
        case 'permissions.add':
          props.modalModel.component = CreateEditPermissionsControllerComponent;
          props.modalModel.modalConfiguration = {
            title: 'Agregar Permiso'
          };
          break;
        case 'permissions.edit':
          props.modalModel.component = CreateEditPermissionsControllerComponent;
          props.modalModel.modalConfiguration = {
            title: 'Editar Permiso'
          };
          break;
        case 'permissions.delete':
          this.delete(event.data);
          return false;
      }
      return props;
    }
    add(): void {
      this.broadcast.fire({
        name: 'permissions.add',
        type: EventType.MODAL,
        data: {}
      });
    }
    delete(data): void {
      const swalParams = {
        title: '¿Estás seguro de querer eliminar este permiso?',
        text: 'El permiso será marcado como eliminado, pero podrá restaurarse.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      };
    
      this.swal.warning(swalParams).then(result => {
        if (result.value) {
          this.permissionsService.delete(data.item.id).subscribe(response => {
            this.swal.success({ title: 'Cliente eliminado con éxito' }).then(() => {
              this.broadcast.reloadDataTable();
            });
          }, error => {
            console.error('Error al eliminar:', error);
            this.swal.error('Ocurrió un error al intentar eliminar el cliente');
          });
        }
      });
    }
}
